export function statesStockToBuyers(listing: {
  intent?: string | null;
}): boolean {
  return listing.intent === "recycle";
}
